import { jsx as _jsx } from "react/jsx-runtime";
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTiposContratos } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposContratos() {
    return (_jsx(GridBase, { pagina: PAGINAS.CC_TIPOS_CONTRATOS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_CONTRATOS, rota: ROUTES.CC_TIPOS_CONTRATOS, columns: COLUNAS, filtrosIniciais: { situacao: '-1' }, fetchData: function (busca, filtros, paginacao) { return getTiposContratos(busca, filtros.situacao === '-1' ? null : filtros.situacao, paginacao); }, renderFiltros: function (filtros, atualizar) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizar({ situacao: novaSituacao });
            } })); } }));
}
